import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/product-east-to-west")({
  component: () => <Outlet />,
});
